// noinspection NonAsciiCharacters


import {Position} from "../model/round";

export function getBearing(p1: Position, p2: Position) {
    const φ1 = toRadians(p1.lat);
    const φ2 = toRadians(p2.lat);
    const Δλ = toRadians(p2.lon - p1.lon);

    const y = Math.sin(Δλ) * Math.cos(φ2);
    const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
    const θ = Math.atan2(y, x);

    return (toDegrees(θ) + 360) % 360;
}

export function distanceMeters(p1: Position, p2: Position) {
    if (!p1 || !p2) {
        return;
    }
    const R = 6371000; // m
    const φ1 = toRadians(p1.lat);
    const φ2 = toRadians(p2.lat);
    const Δφ = toRadians((p2.lat - p1.lat));
    const Δλ = toRadians(p2.lon - p1.lon);

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

export function getCenterAndZoom(tee: Position, green: Position, shots: any[], dstFunc: any, div: any) {
    if (!dstFunc) {
        return;
    }
    let fsh, maxLat = green.lat, maxLon = green.lon, minLat = maxLat, minLon = maxLon;
    for (let i = 0; shots && i < shots.length; ++i) {
        var p = shots[i].pos;
        if (p && p.lat && p.lon) {
            if (!fsh) {
                fsh = shots[i].pos;
            }
            countPoint(p);
        }
    }
    let st = tee;
    if (fsh) {
        const dst = dstFunc(fsh, green);
        if (dst > 100 && dst < 1000) {
            st = fsh;
        }
    }
    countPoint(st);
    countPoint(green);

    const mw = div.offsetWidth / 1.5 - 50; // map view port width + padding 2*25px
    const ground_resolution = dstFunc(st, green) / mw;
    const zoom = Math.log((Math.cos(st.lat * Math.PI / 180) * 2 * Math.PI * 6378137) / (256 * ground_resolution)) / Math.log(2);

    return {
        zoom: Math.floor(zoom),
        centerLat: (minLat + maxLat) / 2,
        centerLon: (minLon + maxLon) / 2
    };

    function countPoint(p: Position) {
        maxLat = Math.max(maxLat, p.lat);
        maxLon = Math.max(maxLon, p.lon);
        minLat = Math.min(minLat, p.lat);
        minLon = Math.min(minLon, p.lon);
    }
}

function toRadians(num: number) {
    return num * Math.PI / 180;
}

function toDegrees(num: number) {
    return num * 180 / Math.PI;
}
